<template>
	<b-container v-if="!isLoggedIn" fluid class="page">
		<b-row>
			<b-col lg="4" md="5" class="mh-login-left">
				<div class="mh-login-logo">
					<img src="../assets/images/logo.png" alt="Mopane Health">
				</div>
				<div class="mh-login-content mb-5">
					<h1>Sign In</h1>
					<p>Access the Mopane Health Facilities</p>
					<b-button v-if="googleOAuth2ClientID" v-google-signin-button="googleOAuth2ClientID" variant="light" class="btn-default btn-grey mh-google-login"><img src="../assets/images/google.png" alt="Google">Sign in with Google</b-button>
					<span v-if="googleOAuth2ClientID" class="mh-or">OR</span>
					<b-form-input type="text" placeholder="Username" v-model="username" autocomplete="off" @keyup.enter="onSubmit()" class="mb-2" />
					<b-form-input type="password" placeholder="Password" v-model="password" autocomplete="off" @keyup.enter="onSubmit()" class="mb-2" />
					<b-form-input v-if="!isProduction" type="text" placeholder="Company Code" v-model="companyCode" autocomplete="off" @keyup.enter="onSubmit()" class="mb-2" />
					<div class="mh-login-help">
						<b-row no-gutters>
							<b-col lg="6" md="12">
								<div class="mh-remember">
									<input type="checkbox" id="remember" v-model="rememberMe" />
									<label for="remember">Remember me</label>
								</div>
							</b-col>
							<b-col lg="6" md="12">
								<a href="#" @click="showPage('ForgotPasswordPage')">Forgot Password?</a>
							</b-col>
						</b-row>
					</div>
					<button class="btn btn-default" @click="login">Sign In</button>
				</div>
				<div class="mh-register-copyright"><p>&copy; MOPANE HEALTH 2021. All Rights Reserved.</p></div>
			</b-col>
			<b-col lg="8" md="7" align-self="center" class="text-center">
				<div class="mh-login-img">
					<div>
						<img src="../assets/images/login-graphic.png" alt="Login" class="img-fluid">
					</div>
				</div>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import GoogleSignInButton from "vue-google-signin-button-directive"
	import appSettings from "../../appconfig.json"

	export default {
		name: 'LoginPage',
		components: {
			GoogleSignInButton
		},
		data: function () {
			return {
				username: null,
				password: null,
				companyCode: null,
				rememberMe: false
			}
		},
		mounted() {
			if (this.isDevelopment) {
				this.username = "gnhema"
				this.password = "Ze6YaqMtQLH2Agywds7!"
				this.companyCode = "mopane"
				this.rememberMe = true
			}

			if (this.isProduction) {
				this.companyCode = "mopane"
			}

			if (!this.isDevelopment && !this.isProduction && localStorage.rememberMe != null && localStorage.rememberMe) {
				this.username = localStorage.username
				this.rememberMe = localStorage.rememberMe == "true"
				this.companyCode = localStorage.companyCode
			}
		},
		computed: {
			environments: function () {
				return this.$store.state.MopaneApi.environments
			},
			isDevelopment: function () {
				return process.env.NODE_ENV === this.environments.development
			},
			isProduction: function () {
				return process.env.NODE_ENV === this.environments.production
			},
			googleOAuth2ClientID: function () {
				return appSettings.mopaneApi.googleOAuth2ClientID
			},
			isLoggedIn: function () {
				return this.$store.state.Profile != undefined && this.$store.state.Profile.isLoggedIn
			},
			usernameValid: function () {
				if (this.username == null || this.username == "") {
					this.$store.commit("Toasts/showError", { title: "Username", content: "Username is required" })

					return false
				}

				return true
			},
			passwordValid: function () {
				if (this.password == null || this.password == "") {
					this.$store.commit("Toasts/showError", { title: "Password", content: "Password is required" })

					return false
				}

				return true
			},
			companyCodeValid: function () {
				if (this.isProduction)
					return true

				if (this.companyCode == null || this.companyCode == "") {
					this.$store.commit("Toasts/showError", { title: "Comapny Code", content: "Company Code is required" })

					return false
				}

				return true
			}
		},
		methods: {
			onSubmit: function () {
				this.login()
			},
			isGoogleLoginValid: function () {
				return this.companyCodeValid
			},
			OnGoogleAuthSuccess: function (token) {
				if (!this.isGoogleLoginValid())
					return

				var $this = this

				this.$store.dispatch("MopaniApi/serverUrl", this.companyCode).then(function () {
					var parameters = {
						token: token,
						companyCode: $this.companyCode
					}

					$this.$store.dispatch("Profile/googleLogin", parameters)
				})
			},
			OnGoogleAuthFail(error) {
				console.log(error)
			},
			isLoginFormValid: function () {
				return this.usernameValid
					&& this.passwordValid
					&& this.companyCodeValid
			},
			login: function () {
				if (!this.isLoginFormValid())
					return

				if (this.rememberMe) {
					localStorage.rememberMe = true
					localStorage.username = this.username

					if (!this.isProduction)
						localStorage.companyCode = this.companyCode
				}
				else {
					localStorage.rememberMe = false
					localStorage.removeItem("username")

					if (!this.isProduction)
						localStorage.removeItem("companyCode")
				}

				var $this = this

				this.$store.dispatch("MopaneApi/serverUrl", this.companyCode).then(function () {
					var credentials = {
						username: $this.username,
						password: $this.password,
						companyCode: $this.companyCode
					}

					$this.$store.dispatch("Profile/login", credentials)
				})
			},
			showPage: function (page) {
				this.$store.dispatch("Pages/show", page)
			}
		}
	}
</script>

<style scoped>
	.mh-login-logo img {
		width: 100%;
	}
</style>